import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Response } from "../helpers/Fetcher";

interface FetchProps<T> {
  initialData?: T;
  showToast?: boolean;
  initialLoading?: boolean;
  storeWholeResponse?: boolean;
  onSuccess?: (data: T) => void;
  onLoadRequest?: Promise<Response<T>>;
}

const useFetch = <T = any | undefined>(props?: FetchProps<T>) => {
  const [error, setError] = useState<string>();
  const [success, setSuccess] = useState(false);
  const [status, setStatus] = useState<number>();
  const [usageCount, setUsageCount] = useState(0);
  const [successResponse, setSuccessResponse] = useState<T | undefined>(
    props?.initialData
  );
  const [isLoading, setLoader] = useState(
    props?.initialLoading === undefined ? false : props.initialLoading
  );
  // show video
  const ShowToast = props?.showToast === undefined ? true : props.showToast;

  useEffect(() => {
    if (props?.onLoadRequest) {
      load(props.onLoadRequest);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // run the a callback on success
    if (successResponse && props && props.onSuccess)
      props.onSuccess(successResponse);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successResponse]);

  const clearError = () => {
    if (error) setError("");
  };

  const load = async (aPromise: Promise<Response<T>>) => {
    setLoader(true);
    clearError();
    return aPromise
      .then((res) => {
        if (String(res.customStatus).startsWith("2")) {
          setSuccess(true);
          setSuccessResponse(props?.storeWholeResponse ? (res as T) : res.data);
        }
        return res;
      })
      .catch((er: Response) => {
        setStatus(er.status);
        setSuccessResponse(undefined);
        if (er.message) {
          if (ShowToast) {
            toast.error(er.message);
          }
          setError(er.message);
          throw new Error(er.message || "");
        } else {
          if (ShowToast) {
            toast.error(er.error);
          }
          setError(er.error);
          throw new Error(er.error);
        }
      })
      .finally(() => {
        setLoader(false);
        setUsageCount((prev) => prev + 1);
      });
  };

  return {
    isLoading,
    successResponse,
    usageCount,
    setUsageCount,
    load,
    error,
    status,
    setLoader,
    clearError,
    setError,
    success,
    setSuccess,
  } as const;
};

export default useFetch;
